import { observable, autorun } from 'mobx'

export const isBrowser = !navigator.userAgent.match(/Node\.js/i)

const localData = JSON.parse((isBrowser && localStorage.getItem('fec-auth')) || '{}')
export const store = observable({
  auth: localData,
  vimeoIds: null,
  loginFailed: false,
  loginLoading: false
})
autorun(() => {
  if (isBrowser && store.auth.refreshToken) {
    localStorage.setItem('fec-auth', JSON.stringify(store.auth))
  }
})

export const API = location.host.match(/localhost/) ? {
  endpoint: 'http://localhost:2998',
  client_id: '97d0e6841782821a95f08cfeb2be325ec184faa2de307ad5675dea0c544f1fe7',
  redirect_url: 'http://localhost:3000/members'
} : {
  endpoint: 'https://frontend-center-api.herokuapp.com',
  client_id: 'aaf9455696f5ecb09d9a2bf7ac9f820b2e96660cc5e33c06b9c40e9f58870374',
  redirect_url: 'https://frontend.center/members'
}

/* https://davidwalsh.name/get-absolute-url */
const getAbsoluteUrl = (function() {
	let a;

	return function(url) {
		if(!a) a = document.createElement('a');
		a.href = url;

		return a.href;
	};
})();
export const imageCdn = (url, options) => `https://img.gs/gkdnwwtmch/${options}/${getAbsoluteUrl(url)}`



/** WEBPACK FOOTER **
 ** ./src/lib/utils.js
 **/